/**
 * @generated SignedSource<<a3b9fbdd0ff4740d1ec459cdf7cbd58a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAnonymousMatterQuery$variables = {
  code: string;
  matterId: string;
  tenantId: string;
};
export type useAnonymousMatterQuery$data = {
  readonly anonymousMatter: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"useAttachmentsFragment">;
  } | null;
};
export type useAnonymousMatterQuery = {
  response: useAnonymousMatterQuery$data;
  variables: useAnonymousMatterQuery$variables;
};
const node: ConcreteRequest = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "code"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "matterId"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    v3 = [{
      "kind": "Variable",
      "name": "code",
      "variableName": "code"
    }, {
      "kind": "Variable",
      "name": "matterId",
      "variableName": "matterId"
    }, {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }],
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v5 = [{
      "kind": "Literal",
      "name": "first",
      "value": 100
    }],
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v7 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    },
    v9 = {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }],
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],

      "kind": "Fragment",
      "metadata": null,
      "name": "useAnonymousMatterQuery",
      "selections": [{
        "alias": null,
        "args": v3 /*: any*/,
        "concreteType": "_Matter",
        "kind": "LinkedField",
        "name": "anonymousMatter",
        "plural": false,
        "selections": [v4 /*: any*/, {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useAttachmentsFragment"
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1 /*: any*/, v0 /*: any*/, v2 /*: any*/],

      "kind": "Operation",
      "name": "useAnonymousMatterQuery",
      "selections": [{
        "alias": null,
        "args": v3 /*: any*/,
        "concreteType": "_Matter",
        "kind": "LinkedField",
        "name": "anonymousMatter",
        "plural": false,
        "selections": [v4 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": v5 /*: any*/,
            "concreteType": "AttachmentConnectionType",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "AttachmentConnectionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [v4 /*: any*/, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentLength",
                  "storageKey": null
                }, v6 /*: any*/, {
                  "alias": null,
                  "args": null,
                  "concreteType": "_User",
                  "kind": "LinkedField",
                  "name": "creator",
                  "plural": false,
                  "selections": [{
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }, v4 /*: any*/],

                  "storageKey": null
                }, {
                  "kind": "InlineFragment",
                  "selections": [{
                    "alias": "assignees",
                    "args": v5 /*: any*/,
                    "concreteType": "_AssigneeConnection",
                    "kind": "LinkedField",
                    "name": "_assignees",
                    "plural": false,
                    "selections": [{
                      "alias": null,
                      "args": null,
                      "concreteType": "_AssigneeConnectionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [{
                        "alias": null,
                        "args": null,
                        "concreteType": "_Assignee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [v4 /*: any*/, {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "actor",
                          "plural": false,
                          "selections": [v7 /*: any*/, v4 /*: any*/, v6 /*: any*/],

                          "storageKey": null
                        }, v7 /*: any*/],

                        "storageKey": null
                      }, v8 /*: any*/],

                      "storageKey": null
                    }, v9 /*: any*/],

                    "storageKey": "_assignees(first:100)"
                  }, {
                    "alias": "assignees",
                    "args": v5 /*: any*/,
                    "filters": null,
                    "handle": "connection",
                    "key": "AssigneesPreview__assignees",
                    "kind": "LinkedHandle",
                    "name": "_assignees"
                  }, {
                    "alias": "attachmentsAssignees",
                    "args": null,
                    "concreteType": "_AssigneeConnection",
                    "kind": "LinkedField",
                    "name": "_assignees",
                    "plural": false,
                    "selections": [{
                      "alias": null,
                      "args": null,
                      "concreteType": "_AssigneeConnectionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [{
                        "alias": null,
                        "args": null,
                        "concreteType": "_Assignee",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [v4 /*: any*/, {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "actor",
                          "plural": false,
                          "selections": [v7 /*: any*/, v4 /*: any*/],

                          "storageKey": null
                        }],
                        "storageKey": null
                      }],
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "type": "_HasAssignees",
                  "abstractKey": "__is_HasAssignees"
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "confidential",
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uploadUrl",
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "concreteType": "AttachmentVersion",
                  "kind": "LinkedField",
                  "name": "versions",
                  "plural": true,
                  "selections": [{
                    "alias": "name",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attachmentName",
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "downloadUrl",
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "insertedAt",
                    "storageKey": null
                  }],
                  "storageKey": null
                }, v7 /*: any*/],

                "storageKey": null
              }, v8 /*: any*/],

              "storageKey": null
            }, v9 /*: any*/],

            "storageKey": "attachments(first:100)"
          }, {
            "alias": null,
            "args": v5 /*: any*/,
            "filters": null,
            "handle": "connection",
            "key": "useAttachmentsFragment_attachments",
            "kind": "LinkedHandle",
            "name": "attachments"
          }],
          "type": "HasAttachments",
          "abstractKey": "__isHasAttachments"
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "b9f410983ac8d29a03b1db1a7112a5a0",
      "id": null,
      "metadata": {},
      "name": "useAnonymousMatterQuery",
      "operationKind": "query",
      "text": "query useAnonymousMatterQuery(\n  $matterId: ID!\n  $code: String!\n  $tenantId: ID!\n) {\n  anonymousMatter(matterId: $matterId, code: $code, tenantId: $tenantId) {\n    id\n    ...useAttachmentsFragment\n  }\n}\n\nfragment AssigneesPreview__node_2ON54F on _HasAssignees {\n  __is_HasAssignees: __typename\n  assignees: _assignees(first: 100) {\n    edges {\n      node {\n        id\n        actor {\n          __typename\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AttachmentUpdater_assignees on _HasAssignees {\n  __is_HasAssignees: __typename\n  attachmentsAssignees: _assignees {\n    edges {\n      node {\n        id\n        actor {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AttachmentsListWithVersionsFragment on Attachment {\n  versions {\n    name: attachmentName\n    version\n    downloadUrl\n    insertedAt\n  }\n}\n\nfragment useAttachmentsFragment on HasAttachments {\n  __isHasAttachments: __typename\n  attachments(first: 100) {\n    edges {\n      node {\n        id\n        contentLength\n        name\n        creator {\n          displayName\n          id\n        }\n        ...AssigneesPreview__node_2ON54F\n        ...AttachmentUpdater_assignees\n        confidential\n        uploadUrl\n        ...AttachmentsListWithVersionsFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
(node as any).hash = "7ed0c795706fa6ceb563118ef39406ce";
export default node;